export const theadAdvance = [
  { name: "Nº FORMULARIO", order: "consecutive" },
  { name: "Cod operacion", order: "consecutive" },
  { name: "Empresa", order: "name_qualified" },
  { name: "Tipo de documento", order: "consecutive" },
  { name: "Factura comercial", order: "nit_qualified" }
];
